import { render, staticRenderFns } from "./DialogAprovarOrcamento.vue?vue&type=template&id=f99d516a&"
import script from "./DialogAprovarOrcamento.vue?vue&type=script&lang=js&"
export * from "./DialogAprovarOrcamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports